/* eslint-disable react/no-array-index-key */
/* eslint-disable no-nested-ternary */
import React, {useEffect, useRef, useState} from 'react'
import { shape, arrayOf, string } from 'prop-types'
import AsdaCustomLink from 'components/asda-custom-link'
import SubMenuHamBurger from 'components/secondary-nav/SubMenuHamBurger'
import {getModifiedStringForNav} from "../../../services/utility/cms";

const GuidedNav = ({
  moduleData: {
    Menu: sectionMain,
  },
  ui,
  name,
  type,
  moduleId,
}) => {
  const [selectedMenuIndex, setSelectedMenuIndex] = useState(-1)

  useEffect(()=>{
    if(!ui.leftNavOpen){
      setSelectedMenuIndex(-1)
    }
  },[ui.leftNavOpen])

  return (
    <React.Fragment>
      {
        selectedMenuIndex !== -1 && <div className="background-shadow-large"/>
      }
      <ul
        data-module={name}
        data-module-name={name}
        data-module-id={moduleId}
        data-module-type={type}
        role="none"
      >
        {sectionMain.map(({
        MainMenu: {
          link: {
            clickThrough: {
              value,
            },
            title,
          },
          IsSubNav: isSubNav,
        },
        SubNav,
    }, index) => {
        const linkObj = { path: value }
        return isSubNav === 'true' ? <SubMenuHamBurger
            link={linkObj}
            linkName={getModifiedStringForNav(title, 20)}
            ui={ui}
            key={`SubMenuHamBurger-${index}`}
            onMenuClick={(isOpen) => setSelectedMenuIndex(isOpen ? -1 : index)}
            SubNav={SubNav}
            isOpen={selectedMenuIndex === index}
            />
        : <AsdaCustomLink
            link={linkObj}
            linkName={getModifiedStringForNav(title, 20)}
            key={`AsdaCustomLink-${index}`}
        />
        })}

      </ul>
    </React.Fragment>
  )
}

GuidedNav.propTypes = {
  moduleData: shape({
    Menu: arrayOf(shape({})).isRequired,
  }).isRequired,
  ui: shape({}).isRequired,
  name: string,
  moduleId: string,
  type: string,
}

GuidedNav.defaultProps = {
  name: null,
  moduleId: null,
  type: null,
}

export default GuidedNav



// WEBPACK FOOTER //
// ./components/cms/components/guided-nav.js